import { useMutation, useQuery } from 'react-query';

import { axiosInstances } from './axiosAuth';

export function useApiGet({ endpoint, config = {}, queryKey, axiosConfig = {}, axiosKey = 'auth' }) {
  const axiosInstance = axiosInstances[axiosKey]; // Get instance by key
  const queryOptions = {
    ...config,
  };

  const query = useQuery(queryKey || [endpoint], () => axiosInstance.get(endpoint, axiosConfig), {
    ...queryOptions,
  });

  return query;
}

export function useApiMutation({
  endpoint,
  method,
  config = {},
  axiosConfig = {},
  sendDataInParams = false,
  axiosKey = 'auth',
}) {
  const axiosInstance = axiosInstances[axiosKey]; // Get instance by key
  const queryOptions = {
    ...config,
  };

  const mutation = useMutation(
    (params) => {
      let url = endpoint;
      if (sendDataInParams) {
        // Construct URL with query params
        const queryString = Object.values(params)
          .map((key) => `/${key}`)
          .join('');
        url += `${queryString}`;
        return axiosInstance[method](url, {}, axiosConfig); // No data in the body, sending empty object
      }
      return axiosInstance[method](url, params, axiosConfig); // No data in the body, sending empty object
    },
    {
      ...queryOptions,
    }
  );

  return mutation;
}
